/**
 * Liga a aba "Envio físico" do processo. Desligada, nada é lido e a aba não existe — nem
 * por deep-link, que volta para a Visão geral.
 *
 * Função, e não constante de módulo, para o teste conseguir alternar a flag com
 * `vi.stubEnv` sem recarregar o módulo.
 *
 * TODO(86akagnv5): dono da flag e data de sunset a definir (DoD da task). Depois do sunset,
 * apagar esta função e o `mostrarAba` passa a depender só da leitura da API.
 */
export const envioFisicoArHabilitado = (): boolean =>
  process.env.NEXT_PUBLIC_ARBITRAL_ENVIO_FISICO_ENABLED === 'true';
